export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updateSubscriptions(state, value) {
    state.subscriptions = value
  }
}
